import { CommercialCardOrientation } from '../../../../../../components/commercialCard/types/commercialCardOrientation';
import { commonStyles } from '../commonStyles/common';
import { horizontalIconCommonStyles } from '../commonStyles/horizontalIconCommon';
import { verticalIconCommonStyles } from '../commonStyles/verticalIconCommon';
import { CommercialCardVariant } from '../variants';
export const getDefaultIconStyles = (FOUNDATIONS, FONT) => {
    return {
        [CommercialCardVariant.DEFAULT_ICON]: {
            ...commonStyles(FOUNDATIONS, FONT),
            [CommercialCardOrientation.VERTICAL]: {
                ...verticalIconCommonStyles(FOUNDATIONS, FONT),
            },
            [CommercialCardOrientation.HORIZONTAL]: {
                ...horizontalIconCommonStyles(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=defaultIcon.js.map